import React from "react";
import Strings from "../utils/stringUtil";
import Intro from "../components/businessLoan/intro";
import Seo from "../components/seo";
import styles from "../assets/styles/loan.module.css";
import LoanForWomenCard from "../components/businessLoan/loanForWomenCard";
import WhyLoan from "../components/businessLoan/whyLoan";
import Offerings from "../components/businessLoan/offerings";
import Eligibility from "../components/businessLoan/eligibility";
import EmiCalculator from "../components/businessLoan/emiCalculator";
import HowToApply from "../components/businessLoan/howToApply";
import CustomerSupport from "../components/businessLoan/customerSupport";
import ReadyToGrow from "../components/businessLoan/readyToGrow";
import ImpactStories from "../components/businessLoan/impactStories";
import BusinessLoanFaqs from "../components/businessLoan/businessLoanFaqs";
import RelatedProducts from "../components/businessLoan/relatedProducts";
import { Box } from "@mui/material";
import { businessLoanSchemaMarkup } from "../utils/schemaUtil";

function BusinessLoan() {
  return (
    <Box style={{ overflowX: "hidden" }}>
      <Seo
        title={Strings.BusinessLoanTitle}
        description={Strings.BusinessLoanMetaDescription}
        keywords={Strings.BusinessLoanMetaKeyword}
        schema={businessLoanSchemaMarkup}
      />
      <div className={styles.greenBg}>
        <Intro />
        <LoanForWomenCard />
        <WhyLoan />
      </div>
      <Offerings />
      <Eligibility />
      <EmiCalculator />
      <HowToApply />
      <CustomerSupport />

      <div className={styles.greenBg}>
        <ReadyToGrow />
        <ImpactStories />
      </div>

      <BusinessLoanFaqs />
      {/* <RelatedProducts /> */}
    </Box>
  );
}

export default BusinessLoan;
